import axiosClient from "./axiosClient";
const authenticationService = {
  login: async (params) => {
    const url = `/auth/signin_admin`;
    const response = await axiosClient.post(url, params);
    return response;
  },
};

export default authenticationService;
